<template>
  <CModal size="lg" scrollable :visible="isOpenModalSearch" @close="() => { $emit('close') }">
    <CModalHeader>
      <CModalTitle>Buscador</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <div class="mb-3 px-4">
        <CInputGroup class="flex-nowrap custom-search-group">
          <CInputGroupText class="bg-white border-end-0 text-muted">
            <CIcon icon="cilSearch" />
          </CInputGroupText>
          <CFormInput 
            v-model="filter"
            placeholder="Busca vehículos, parther, clientes..." 
            class="border-start-0 ps-0 shadow-none" 
          />
        </CInputGroup>
      </div>
      <div class="py-2" />

      <div v-if="filter_vehicles.length" class="mb-3">
        <h6 class="text-muted fw-bold small">
          Vehículos <span class="fw-normal">({{ filter_vehicles.length }})</span>
        </h6>
      </div>

      <div v-if="filter_vehicles.length" class="vehicle-list custom-scrollbar" style="height: 350px; overflow-y: auto;">
        <div v-for="car in filter_vehicles" :key="car.id" @click="redirect({ name: 'Editar Vehículo', params: { id: car.id }})" class="d-flex align-items-center py-3 border-bottom me-2">
          <div class="flex-shrink-0">
            <CImage 
              :src="baseURL+car.photo" 
              class="rounded" 
              width="64" 
              height="64" 
              style="object-fit: cover;" 
            />
          </div>

          <div class="flex-grow-1 ms-3">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <span class="fw-bold text-dark mb-0 me-2">
                {{ car.brand }} <span class="fw-normal">{{ car.model }}</span>
              </span>
              
              <CBadge color="light" text-color="secondary" shape="rounded-pill" class="border">
                {{ car.status }}
              </CBadge>
            </div>
            
            <div class="text-muted mt-1">
              {{ car.sale_price }}
            </div>
          </div>
        </div>
      </div>
      
      <div v-if="filter_parthers.length" class="mb-3">
        <h6 class="text-muted fw-bold small">
          Parthers <span class="fw-normal">({{ filter_parthers.length }})</span>
        </h6>
      </div>

      <div v-if="filter_parthers.length" class="vehicle-list custom-scrollbar" style="height: 350px; overflow-y: auto;">
        <div v-for="parther in filter_parthers" :key="parther.id" class="d-flex align-items-center py-3 border-bottom me-2">
          <div class="flex-shrink-0">
            <div class="flex-shrink-0">
              <div class="d-flex align-items-center justify-content-center rounded-3 bg-light-gray text-dark-blue" style="width: 60px; height: 60px;">
                <CIcon icon="cilUser" size="xl" /> 
              </div>
            </div>
          </div>

          <div class="flex-grow-1 ms-3">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <span class="fw-bold text-dark mb-0 me-2">
                {{ parther.first_name }} {{ parther.last_name }}
              </span>
              
              <!--<CBadge color="light" text-color="secondary" shape="rounded-pill" class="border">
                {{ car.status }}
              </CBadge>-->
            </div>
          </div>
        </div>
      </div>

      <div v-if="filter_customers.length" class="mb-3">
        <h6 class="text-muted fw-bold small">
          Parthers <span class="fw-normal">({{ filter_customers.length }})</span>
        </h6>
      </div>

      <div v-if="filter_customers.length" class="vehicle-list custom-scrollbar" style="height: 350px; overflow-y: auto;">
        <div v-for="customer in filter_customers" :key="customer.id" class="d-flex align-items-center py-3 border-bottom me-2">
          <div class="flex-shrink-0">
            <div class="d-flex align-items-center justify-content-center rounded-3 bg-light-gray text-dark-blue" style="width: 60px; height: 60px;">
              <CIcon icon="cilUser" size="xl" /> 
            </div>
          </div>

          <div class="flex-grow-1 ms-3">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
              <span class="fw-bold text-dark mb-0 me-2">
                {{ customer.nombre }}
              </span>
              
              <!--<CBadge color="light" text-color="secondary" shape="rounded-pill" class="border">
                {{ car.status }}
              </CBadge>-->
            </div>
          </div>
        </div>
      </div>
    </CModalBody>
  </CModal>
</template>
<script>
  import axios from 'axios';

  export default {
    props:['isOpenModalSearch'],
    data() {
      return {
        baseURL: axios.defaults.baseURL,
        filter: '',
        vehicles: [],
        parthers: [],
        customers: [],
      }
    },
    created(){
      this.getUsers()
      this.getVehicleTransactions()
      this.getCustomers()
    },
    computed:{
      filter_vehicles(){
        if (this.filter == '') {
          return []
        }
        
        let filter = this.filter.toLowerCase()

        return this.vehicles.filter(vehicle => {
          return vehicle?.location?.name?.toString().toLowerCase().includes(filter)  ||
            vehicle?.fuel?.name?.toString().toLowerCase().includes(filter) ||
            vehicle?.brand?.toString().toLowerCase().includes(filter) ||
            vehicle?.registration?.toString().toLowerCase().includes(filter) ||
            vehicle?.users[0].first_name?.toString().toLowerCase().includes(filter) ||
            vehicle?.users[0].last_name?.toString().toLowerCase().includes(filter) ||
            vehicle?.year?.toString().toLowerCase().includes(filter) ||
            vehicle?.kilometers?.toString().toLowerCase().includes(filter) ||
            vehicle?.model?.toString().toLowerCase().includes(filter);
        })
      },
      filter_parthers(){
        if (this.filter == '') {
          return []
        }
        
        let filter = this.filter.toLowerCase()

        return this.parthers.filter(parther => {
          return parther?.first_name?.toString().toLowerCase().includes(filter)  ||
            parther?.last_name?.toString().toLowerCase().includes(filter) ||
            parther?.email?.toString().toLowerCase().includes(filter);
        })
      },
      filter_customers(){
        if (this.filter == '') {
          return []
        }
        
        let filter = this.filter.toLowerCase()

        return this.customers.filter(parther => {
          return parther?.nombre?.toString().toLowerCase().includes(filter)  ||
            parther?.dni_nif?.toString().toLowerCase().includes(filter) ||
            parther?.email?.toString().toLowerCase().includes(filter);
        })
      }
    },
    methods:{
      redirect(path){
        this.$emit('close')
        
        if(this.$route.name == 'Editar Vehículo')
          this.$router.replace({ id: path.params.id });
        
        this.$router.push(path);
      },
      getUsers() {
        axios
        .get("api/users")
        .then(res => {
          this.parthers = res.data.data
        })
        .catch(err => console.log(err));
      },
      getVehicleTransactions() {
        axios
        .get("api/vehicle_transactions")
        .then(res => {
          console.log(res.data)
          this.vehicles = res.data.data
        })
        .catch(err => console.log(err));
      },
      getCustomers() {
        axios
          .get("api/customers")
          .then(res => {
            this.customers = res.data.data;
          })
          .catch(err => console.log(err));
      },
    }
  }
</script>
<style>
  .modal {
    --cui-modal-margin: 4.75rem;
  }

</style>